__turbopack_context__.v({
  "dateTimePicker": "CreateForm-module__UX2bOq__dateTimePicker",
  "grid": "CreateForm-module__UX2bOq__grid",
  "mantine-DateTimePicker-input": "CreateForm-module__UX2bOq__mantine-DateTimePicker-input",
  "mantine-Input-input": "CreateForm-module__UX2bOq__mantine-Input-input",
  "mantine-Input-wrapper": "CreateForm-module__UX2bOq__mantine-Input-wrapper",
  "mantine-NumberInput-input": "CreateForm-module__UX2bOq__mantine-NumberInput-input",
  "mantine-Select-input": "CreateForm-module__UX2bOq__mantine-Select-input",
  "mantine-Switch-thumb": "CreateForm-module__UX2bOq__mantine-Switch-thumb",
  "mantine-Switch-track": "CreateForm-module__UX2bOq__mantine-Switch-track",
  "reactAudioPlayer": "CreateForm-module__UX2bOq__reactAudioPlayer",
  "row": "CreateForm-module__UX2bOq__row",
  "switchThumb": "CreateForm-module__UX2bOq__switchThumb",
  "switchTrack": "CreateForm-module__UX2bOq__switchTrack",
  "transparentBackground": "CreateForm-module__UX2bOq__transparentBackground",
  "transparentSwitch": "CreateForm-module__UX2bOq__transparentSwitch",
  "underConstruction": "CreateForm-module__UX2bOq__underConstruction",
});
